// 筛选条件
enum Filters {
    '渠道',
    '日期区间',
    '订单状态',
    '汇款状态',
    '品牌'
}
//图片类型
export enum ImgTypes {
    '图片' = 1,
    'logo'
}
//下载类型
export enum LoadTypes {
    '生成中' = 1,
    '生成完成'
}
//图片类型
export enum ProductTypes {
    '全部',
    '商品图片',
    '详情图'
}
export enum Branches {
    'business',
    'finance',
    'operation',
    'service',
    'common' = 100,
}

export const exportTypeFilters = {
    "财务-结算订单": {
        target: 'channel_no_order',
        filters: [Filters[0], Filters[1]]
    },
    "财务-订单明细": {
        target: 'order',
        filters: [Filters[0], Filters[1], Filters[2], Filters[3], Filters[4]]
    },
    "客服-订单明细": {
        target: 'order',
        filters: [Filters[0], Filters[1], Filters[2], Filters[3], Filters[4]]
    },
}

export const roleExportTypes = {
    finance: ['财务-结算订单', '财务-订单明细'],
    service: ['客服-订单明细']
}
